import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.customerDebtReport;
export const customerDebtReportRoute = {
    path: rootPath,
    lazy: async () => {
        const { CustomerDebtReportContainer } = await import('@/admin/modules/reports/customers');
        return {
            element: (_jsx(ProtectedRoute, { claims: claimIds, children: _jsx(CustomerDebtReportContainer, {}) })),
        };
    },
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
};
